var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9294 13.2973L17.5169 15.827L19.6774 14.6327L21.8379 15.827L21.4254 13.2973L23.1734 11.5059L20.7577 11.1367L19.6774 8.83496L18.5971 11.1367L16.1814 11.5059L17.9294 13.2973Z",
    fill: "#2D38AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9555 22.2362C14.8173 22.2362 15.516 21.5376 15.516 20.6757C15.516 19.8139 14.8173 19.1152 13.9555 19.1152C13.0937 19.1152 12.395 19.8139 12.395 20.6757C12.395 21.5376 13.0937 22.2362 13.9555 22.2362Z",
    fill: "#2D38AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3951 31.6002H15.516V27.4389L16.5564 26.9188V24.318C16.5564 23.7661 16.3371 23.2369 15.947 22.8467C15.5568 22.4565 15.0275 22.2373 14.4757 22.2373H13.4354C12.8836 22.2373 12.3543 22.4565 11.9641 22.8467C11.5739 23.2369 11.3547 23.7661 11.3547 24.318V26.9188L12.3951 27.4389V31.6002Z",
    fill: "#2D38AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6772 20.1317C20.539 20.1317 21.2377 19.4331 21.2377 18.5712C21.2377 17.7094 20.539 17.0107 19.6772 17.0107C18.8154 17.0107 18.1167 17.7094 18.1167 18.5712C18.1167 19.4331 18.8154 20.1317 19.6772 20.1317Z",
    fill: "#2D38AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0764 22.2135V24.8143L18.1167 25.3344V29.4957H21.2377V25.3344L22.278 24.8143V22.2135C22.278 21.6616 22.0588 21.1324 21.6686 20.7422C21.2784 20.352 20.7492 20.1328 20.1974 20.1328H19.1571C18.6052 20.1328 18.076 20.352 17.6858 20.7422C17.2956 21.1324 17.0764 21.6616 17.0764 22.2135Z",
    fill: "#2D38AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3991 22.2362C26.2609 22.2362 26.9596 21.5376 26.9596 20.6757C26.9596 19.8139 26.2609 19.1152 25.3991 19.1152C24.5373 19.1152 23.8386 19.8139 23.8386 20.6757C23.8386 21.5376 24.5373 22.2362 25.3991 22.2362Z",
    fill: "#2D38AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7983 24.318V26.9188L23.8387 27.4389V31.6002H26.9596V27.4389L28 26.9188V24.318C28 23.7661 27.7808 23.2369 27.3906 22.8467C27.0004 22.4565 26.4711 22.2373 25.9193 22.2373H24.879C24.3272 22.2373 23.7979 22.4565 23.4077 22.8467C23.0176 23.2369 22.7983 23.7661 22.7983 24.318Z",
    fill: "#2D38AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR4);
export default __webpack_public_path__ + "static/media/r4.48137ddb65334978a6259aab0451cce9.svg";
export { ForwardRef as ReactComponent };